export default "__VITE_ASSET___ZuY_O11__"